export default {
    abs: "абс.",
    activate: "Іске қосу",
    add_category: "Санатты қосу",
    add_kit: "Жинақ қосыңыз",
    additional_materials: "Қосымша материалдар",
    archive: "Мұрағат",
    are_you_sure_you_want_to_delete_category: "Санатты жойғыңыз келе ме?",
    are_you_sure_you_want_to_delete_service: "Қызметті жойғыңыз келе ме?",
    assistant_reward: "Көмекшінің сыйақысы",
    average_price: "Орташа бағасы",
    categories: "Санаттар",
    category: "Санат",
    change_category: "Санатты өзгерту",
    change_pricelist: "Прайсты өзгерту",
    classificator_code: "Жіктелім бойынша код",
    classificator_title: "Жіктелім бойынша атауы",
    complex_service: "Кешенді қызмет",
    complex_services: "Кешенді қызметтер",
    curator_reward: "Куратордың сыйақысы",
    current_value: "Ағымдағы құны",
    deactivate: "Жансыздану",
    decrease_price: "Бағаны төмендету",
    discounted_price: "Жеңілдікпен баға",
    do_not_accrue_bonus: "Бонусты есептемеу",
    doctor_reward: "Дәрігердің сыйақысы",
    fill_from_previous_visits: "Алдыңғы сапарлардан толтырыңыз",
    fixed_materials_expense_sum: "Материалдардың тіркелген шығын сомасы",
    import_standard_services: "Стандартты қызметтер импорты",
    increase_price: "Бағаны арттыру",
    individual_bonus: "Пациентке жеке бонус (%)",
    make_separate: "Оны бөлек жасаңыз",
    manager: "Әкімші",
    manager_reward: "Әкімшінің свйақысы",
    mkb_10_diagnosis: "ICD 10 бойынша диагноз",
    money_lost_on_discount: "Жеңілдіктерде ақшаны жоғалту",
    move_to_group: "Топқа көшу",
    ndfl_code: "НДФЛ коды",
    not_selected: "Белгіленген жоқ",
    packages_cost: "Кешендерді өзіндік құны",
    personal_percent_for_assistant: "Ассистент үшін дербес пайыз",
    personal_percent_for_curator: "Куратор үшін дербес пайыз",
    personal_percent_for_doctor: "Дәрігер үшін дербес пайыз",
    personal_percent_for_manager: "Әкімші үшін дербес пайыз",
    personal_percent_for_technic: "Техник үшін дербес пайыз",
    price_can_be_changed: "Баға емдеу карточкасында өзгертілуі мүмкін",
    price_from: "Бағасы",
    pricelist_price: "Прайс бойынша бағасы",
    pricelist_short: "Прайс",
    reset_selection: "Таңдауды ысыру",
    send_to_archive: "мұрағатқа жіберу",
    Service: "Қызмет",
    service_category: "Санат",
    service_code: "Қызметтер коды",
    services_not_selected: "Ешбір қызмет таңдалмаған",
    technic: "Техник",
    technic_reward: "Техник сыйақысы",
    teeth_not_selected: "Тіс таңдалмаған",
    use_visit_anamnez: "Бару тарихын пайдаланыңыз",
    visit_status: "Күйге бару"
}
